// 全局状态管理
interface ILoading {
  tip: string;
  spinning: boolean;
}

export const globalStatus = {
  name: "globalStatus",
  state: {
    // 加载状态
    loading: {
      tip: "",
      spinning: false
    } as ILoading,
    // 导出进程
    exportProcess: {
      num: 0,
      status: null
    },
    // 下载进程
    downloadProcess: {
      num: 0,
      status: null
    },
    // 时间戳管理
    tiemstampMg: {
      // 订单列表时间戳
      orderListTimestamp: new Date().getTime()
    },
    // 系统菜单状态管理
    sysMenuMg: {
      // 选中的菜单
      selectedKeys: "",
      // 打开的菜单
      openKeys: []
    }
  },
  reducers: {
    // 更新loading状态
    updateLoading(state, data: ILoading) {
      return {
        ...state,
        loading: { ...state.loading, ...data }
      };
    },
    // 更新导出进程
    updateExportProcess(state, data: any) {
      return {
        ...state,
        exportProcess: { ...state.exportProcess, ...data }
      };
    },
    // 更新下载进度
    updateDownloadProcess(state, data: any) {
      return {
        ...state,
        downloadProcess: { ...state.downloadProcess, ...data }
      };
    },
    // 更新时间戳
    updateTimestamp(state, data: any) {
      return {
        ...state,
        tiemstampMg: {
          ...state.tiemstampMg,
          ...data
        }
      };
    },
    // 更新菜单状态
    updateSysMenuStatus(state, data: any) {
      return {
        ...state,
        sysMenuMg: {
          ...state.sysMenuMg,
          ...data
        }
      };
    }
  }
};
